import { gql } from '@apollo/client';

// ============ AUTH ============

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      accessToken
      refreshToken
      user {
        id
        email
        name
        role
        avatarUrl
        jobTitle
        organization {
          id
          name
          slug
        }
      }
    }
  }
`;

export const GET_ME = gql`
  query GetMe {
    me {
      id
      email
      name
      role
      avatarUrl
      jobTitle
      organization {
        id
        name
        slug
      }
    }
  }
`;

// ============ SHIFTS ============

export const GET_SHIFTS = gql`
  query GetShifts($organizationId: String!, $startDate: String!, $endDate: String!) {
    shifts(organizationId: $organizationId, startDate: $startDate, endDate: $endDate) {
      id
      organizationId
      employeeId
      employee {
        id
        name
        email
        avatarUrl
        jobTitle
      }
      startDate
      endDate
      shiftType
      department
      position
      status
      hours
      breakDuration
      notes
      location
      createdAt
      updatedAt
    }
  }
`;

export const GET_MY_SHIFTS = gql`
  query GetMyShifts($employeeId: String!, $startDate: String!, $endDate: String!) {
    myShifts(employeeId: $employeeId, startDate: $startDate, endDate: $endDate) {
      id
      startDate
      endDate
      shiftType
      department
      position
      status
      hours
      employee {
        id
        name
        avatarUrl
      }
    }
  }
`;

export const GET_SHIFT = gql`
  query GetShift($id: String!) {
    shift(id: $id) {
      id
      organizationId
      employeeId
      employee {
        id
        name
        email
        avatarUrl
      }
      startDate
      endDate
      shiftType
      department
      position
      status
      hours
      breakDuration
      notes
      location
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_SHIFT = gql`
  mutation CreateShift($input: ShiftInput!) {
    createShift(input: $input) {
      id
      startDate
      endDate
      shiftType
      department
      position
      status
      hours
    }
  }
`;

export const UPDATE_SHIFT = gql`
  mutation UpdateShift($id: String!, $input: ShiftUpdateInput!) {
    updateShift(id: $id, input: $input) {
      id
      startDate
      endDate
      shiftType
      status
    }
  }
`;

export const DELETE_SHIFT = gql`
  mutation DeleteShift($id: String!) {
    deleteShift(id: $id) {
      id
    }
  }
`;

export const ASSIGN_SHIFT = gql`
  mutation AssignShift($shiftId: String!, $employeeId: String!) {
    assignShift(shiftId: $shiftId, employeeId: $employeeId) {
      id
      employeeId
      status
    }
  }
`;

// ============ LEAVE ============

export const GET_LEAVE_REQUESTS = gql`
  query GetLeaveRequests($organizationId: String!, $status: String) {
    leaveRequests(organizationId: $organizationId, status: $status) {
      id
      organizationId
      employeeId
      employee {
        id
        name
        email
        avatarUrl
        jobTitle
      }
      leaveType
      startDate
      endDate
      reason
      status
      reviewedAt
      reviewNotes
      createdAt
    }
  }
`;

export const GET_MY_LEAVE_REQUESTS = gql`
  query GetMyLeaveRequests($employeeId: String!) {
    myLeaveRequests(employeeId: $employeeId) {
      id
      leaveType
      startDate
      endDate
      reason
      status
      reviewedAt
      createdAt
    }
  }
`;

export const CREATE_LEAVE_REQUEST = gql`
  mutation CreateLeaveRequest($input: LeaveRequestInput!) {
    createLeaveRequest(input: $input) {
      id
      leaveType
      startDate
      endDate
      reason
      status
      createdAt
    }
  }
`;

export const APPROVE_LEAVE = gql`
  mutation ApproveLeaveRequest($id: String!, $reviewNotes: String) {
    approveLeaveRequest(id: $id, reviewNotes: $reviewNotes) {
      id
      status
      reviewedAt
    }
  }
`;

export const REJECT_LEAVE = gql`
  mutation RejectLeaveRequest($id: String!, $reviewNotes: String) {
    rejectLeaveRequest(id: $id, reviewNotes: $reviewNotes) {
      id
      status
      reviewedAt
    }
  }
`;

export const GET_LEAVE_BALANCE = gql`
  query GetLeaveBalance($employeeId: String!, $year: Int) {
    leaveBalance(employeeId: $employeeId, year: $year) {
      employeeId
      year
      balance
      totalUsed
    }
  }
`;

// ============ DASHBOARD ============

export const GET_DASHBOARD_STATS = gql`
  query GetDashboardStats($organizationId: String!) {
    dashboardStats(organizationId: $organizationId) {
      totalStaff
      shiftsThisWeek
      pendingRequests
      attendanceRate
      coverageRate
      overtimeHours
    }
  }
`;

export const GET_SCHEDULE_STATS = gql`
  query GetScheduleStats($organizationId: String!, $startDate: String!, $endDate: String!) {
    scheduleStats(organizationId: $organizationId, startDate: $startDate, endDate: $endDate) {
      totalShifts
      coveredShifts
      openShifts
      publishedShifts
      coverageRate
      totalHours
      totalOvertime
    }
  }
`;

// ============ SUBSCRIPTIONS ============

export const SHIFT_UPDATED = gql`
  subscription ShiftUpdated($organizationId: String!) {
    shiftUpdated(organizationId: $organizationId) {
      id
      employeeId
      startDate
      endDate
      shiftType
      status
    }
  }
`;

export const LEAVE_REQUEST_CREATED = gql`
  subscription LeaveRequestCreated($organizationId: String!) {
    leaveRequestCreated(organizationId: $organizationId) {
      id
      employeeId
      leaveType
      startDate
      endDate
      status
    }
  }
`;

export const LEAVE_REQUEST_UPDATED = gql`
  subscription LeaveRequestUpdated($organizationId: String!) {
    leaveRequestUpdated(organizationId: $organizationId) {
      id
      status
      reviewedAt
    }
  }
`;
